// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Karla:ital,wght@300;400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Karla", sans-serif;
}

.request-form {
  width: 563px;
  height: 895px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: linear-gradient(to bottom, #ffffff -8%, #e0ece0 59%, #ddebdd 0%);
  font-family: "Karla", sans-serif;
}

.sign-in-form {
  width: 345px;
  height: auto;
}

.form-title {
  text-align: left;
  margin-bottom: 20px;
  color: #051b12;
  font-weight: 500;
  font-size: 55px;
  font-family: "Karla", sans-serif;
  text-shadow: -1px -1px 0 rgba(28, 103, 88, 0.1),
    1px -1px 0 rgba(28, 103, 88, 0.1), -1px 1px 0 rgba(28, 103, 88, 0.1),
    1px 1px 0 rgba(28, 103, 88, 0.1);
}

.request-form h3 {
  text-align: left;
  padding: 25px 10px;
  /* margin-left: -25px; */
  margin-bottom: -22px;
  /* margin-top: 8px; */
  color: #212b27;
  font-weight: 400;
  font-size: 21.01px;
  text-shadow: -1px -1px 0 rgba(28, 103, 88, 0.1),
    1px -1px 0 rgba(28, 103, 88, 0.1), -1px 1px 0 rgba(28, 103, 88, 0.1),
    1px 1px 0 rgba(28, 103, 88, 0.1);
}

/* .date-range,
.details-dropdown,
.email-input,
.reason-input,
.password-input,
.name-input,
.contact-number-input {
  /* margin-bottom: 20px;
} */

.react-datepicker-wrapper,
.details-dropdown select,
.email-input input,
.password-input input,
.name-input input,
.contact-number-input input {
  width: 100%;
}

.select-wrapper {
  position: relative;
  width: 100%;
}

.select-wrapper select {
  appearance: none;
  font-weight: 400;
  color: rgba(17, 17, 19, 0.6);
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 30px;
  border: 0px solid #ccc;
  border-radius: 9px;
  width: 100%;
  height: 45px;
  padding: 10px;
}

.dropdown-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #666;
  pointer-events: none;
  transition: transform 0.3s ease;
}

.dropdown-icon.open {
  transform: translateY(-50%) rotate(180deg);
}

.details-dropdown select {
  font-weight: normal;
}

.react-datepicker-wrapper {
  max-width: 97%;
  margin-right: 93%;
}

.email-input input,
.password-input input,
.name-input input,
.contact-number-input input {
  max-width: 97%;
  margin-right: 93%;
}

.react-datepicker__input-container input,
.details-dropdown select,
.email-input input,
.password-input input,
.name-input input,
.contact-number-input input {
  width: 98%;
  padding: 10px;
  border: 0px solid #ccc;
  border-radius: 10px;
  color: rgba(17, 17, 19, 0.6);
}

.email-input input,
.password-input input,
.name-input input,
.contact-number-input input {
  width: 95%;
}

.reason-input textarea {
  width: 97%;
  height: 100px;
  min-height: 100px;
  max-height: 100px;
  padding: 8px;
  border: 0px solid #ccc;
  border-radius: 9px;
  color: rgba(17, 17, 19, 0.6);
  resize: none;
  overflow-y: auto;
}

.form-buttons {
  margin-top: 15px;
  width: 333px;
  margin-left: 102px;
  & .apply-button {
    padding: 5px 20px 7px 22px;
    font-size: 22px;
    width: auto;
    height: 40px;
  }
}
.forgot-password {
  padding-top: 8px;
  padding-left: 10px;
  cursor: pointer;
  color: #0000ff99;
  letter-spacing: 1px;
  font-size: 14px;
}
.password-toggle-icon {
  position: absolute;
  right: 30px;
  bottom: 30px;
  cursor: pointer;
  font-size: 18px;
  -webkit-user-select: none;
          user-select: none;
}
.edit-button,
.apply-button,
.login-button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  margin-bottom: 30px;
  cursor: pointer;
  font-family: "Karla", sans-serif;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(28, 103, 88, 0.1);
}

.apply-button,
.login-button {
  background-color: #84c7ae;
  color: #ffff;
}

.edit-button {
  margin-left: 400px;
  margin-right: 9px;
  margin-bottom: 24px;
  background-color: #d9d9d9;
  color: rgb(0, 0, 0);
}

.edit-button:hover,
.apply-button:hover,
.login-button:hover {
  opacity: 0.9;
}

.react-datepicker__input-container input::placeholder,
.details-dropdown select,
.email-input input::placeholder,
.reason-input textarea::placeholder,
.password-input input::placeholder,
.name-input input::placeholder,
.contact-number-input input::placeholder {
  font-weight: 400;
  font-size: 15px;
  color: rgba(17, 17, 19, 0.6);
}

.reason-input textarea::placeholder {
  font-family: Karla, sans-serif;
}

.details-dropdown select {
  color: rgba(17, 17, 19, 0.6);
}

.details-dropdown select option {
  font-weight: 400;
  font-size: 12px;
  color: rgba(17, 17, 19, 0.6);
}

.react-datepicker__input-container input,
.email-input input,
.reason-input textarea,
.password-input input,
.name-input input,
.contact-number-input input {
  font-weight: 400;
  font-size: 15px;
  color: rgba(17, 17, 19, 0.6);
}

.sign-in-form .form-title {
  font-size: 40px;
}

.sign-in-form h3 {
  font-size: 18px;
}

.react-datepicker__input-container {
  display: block;
  width: 100%;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown {
  background-color: white;
  border: 1px solid #aeaeae;
  border-radius: 4px;
  padding: 5px;
}

.react-datepicker__year-dropdown {
  height: 200px;
  overflow-y: scroll;
}

.react-datepicker__year-option,
.react-datepicker__month-option {
  padding: 2px 10px;
  cursor: pointer;
}

.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover {
  background-color: #f0f0f0;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow {
  border-color: #aeaeae transparent transparent;
  border-style: solid;
  border-width: 5px 5px 2.5px;
  height: 0;
  margin-top: -2.5px;
  position: absolute;
  right: 5px;
  top: 50%;
  width: 0;
}

/*  */

.password-input-container {
  position: relative;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/utils/RequestForm/RequestForm.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4EAA4E;EAC5E,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC;;oCAEkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB;;oCAEkC;AACpC;;AAEA;;;;;;;;GAQG;;AAEH;;;;;;EAME,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;EAIE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;;;EAME,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB;IACE,0BAA0B;IAC1B,eAAe;IACf,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;;;EAGE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,6CAA6C;EAC7C,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,QAAQ;AACV;;AAEA,KAAK;;AAEL;EACE,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Karla:ital,wght@300;400&display=swap\");\n\nbody {\n  font-family: \"Karla\", sans-serif;\n}\n\n.request-form {\n  width: 563px;\n  height: 895px;\n  margin: 0 auto;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  background: linear-gradient(to bottom, #ffffff -8%, #e0ece0 59%, #ddebdd 0%);\n  font-family: \"Karla\", sans-serif;\n}\n\n.sign-in-form {\n  width: 345px;\n  height: auto;\n}\n\n.form-title {\n  text-align: left;\n  margin-bottom: 20px;\n  color: #051b12;\n  font-weight: 500;\n  font-size: 55px;\n  font-family: \"Karla\", sans-serif;\n  text-shadow: -1px -1px 0 rgba(28, 103, 88, 0.1),\n    1px -1px 0 rgba(28, 103, 88, 0.1), -1px 1px 0 rgba(28, 103, 88, 0.1),\n    1px 1px 0 rgba(28, 103, 88, 0.1);\n}\n\n.request-form h3 {\n  text-align: left;\n  padding: 25px 10px;\n  /* margin-left: -25px; */\n  margin-bottom: -22px;\n  /* margin-top: 8px; */\n  color: #212b27;\n  font-weight: 400;\n  font-size: 21.01px;\n  text-shadow: -1px -1px 0 rgba(28, 103, 88, 0.1),\n    1px -1px 0 rgba(28, 103, 88, 0.1), -1px 1px 0 rgba(28, 103, 88, 0.1),\n    1px 1px 0 rgba(28, 103, 88, 0.1);\n}\n\n/* .date-range,\n.details-dropdown,\n.email-input,\n.reason-input,\n.password-input,\n.name-input,\n.contact-number-input {\n  /* margin-bottom: 20px;\n} */\n\n.react-datepicker-wrapper,\n.details-dropdown select,\n.email-input input,\n.password-input input,\n.name-input input,\n.contact-number-input input {\n  width: 100%;\n}\n\n.select-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.select-wrapper select {\n  appearance: none;\n  font-weight: 400;\n  color: rgba(17, 17, 19, 0.6);\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding-right: 30px;\n  border: 0px solid #ccc;\n  border-radius: 9px;\n  width: 100%;\n  height: 45px;\n  padding: 10px;\n}\n\n.dropdown-icon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid #666;\n  pointer-events: none;\n  transition: transform 0.3s ease;\n}\n\n.dropdown-icon.open {\n  transform: translateY(-50%) rotate(180deg);\n}\n\n.details-dropdown select {\n  font-weight: normal;\n}\n\n.react-datepicker-wrapper {\n  max-width: 97%;\n  margin-right: 93%;\n}\n\n.email-input input,\n.password-input input,\n.name-input input,\n.contact-number-input input {\n  max-width: 97%;\n  margin-right: 93%;\n}\n\n.react-datepicker__input-container input,\n.details-dropdown select,\n.email-input input,\n.password-input input,\n.name-input input,\n.contact-number-input input {\n  width: 98%;\n  padding: 10px;\n  border: 0px solid #ccc;\n  border-radius: 10px;\n  color: rgba(17, 17, 19, 0.6);\n}\n\n.email-input input,\n.password-input input,\n.name-input input,\n.contact-number-input input {\n  width: 95%;\n}\n\n.reason-input textarea {\n  width: 97%;\n  height: 100px;\n  min-height: 100px;\n  max-height: 100px;\n  padding: 8px;\n  border: 0px solid #ccc;\n  border-radius: 9px;\n  color: rgba(17, 17, 19, 0.6);\n  resize: none;\n  overflow-y: auto;\n}\n\n.form-buttons {\n  margin-top: 15px;\n  width: 333px;\n  margin-left: 102px;\n  & .apply-button {\n    padding: 5px 20px 7px 22px;\n    font-size: 22px;\n    width: auto;\n    height: 40px;\n  }\n}\n.forgot-password {\n  padding-top: 8px;\n  padding-left: 10px;\n  cursor: pointer;\n  color: #0000ff99;\n  letter-spacing: 1px;\n  font-size: 14px;\n}\n.password-toggle-icon {\n  position: absolute;\n  right: 30px;\n  bottom: 30px;\n  cursor: pointer;\n  font-size: 18px;\n  user-select: none;\n}\n.edit-button,\n.apply-button,\n.login-button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  margin-bottom: 30px;\n  cursor: pointer;\n  font-family: \"Karla\", sans-serif;\n  font-weight: bold;\n  text-shadow: 1px 1px 2px rgba(28, 103, 88, 0.1);\n}\n\n.apply-button,\n.login-button {\n  background-color: #84c7ae;\n  color: #ffff;\n}\n\n.edit-button {\n  margin-left: 400px;\n  margin-right: 9px;\n  margin-bottom: 24px;\n  background-color: #d9d9d9;\n  color: rgb(0, 0, 0);\n}\n\n.edit-button:hover,\n.apply-button:hover,\n.login-button:hover {\n  opacity: 0.9;\n}\n\n.react-datepicker__input-container input::placeholder,\n.details-dropdown select,\n.email-input input::placeholder,\n.reason-input textarea::placeholder,\n.password-input input::placeholder,\n.name-input input::placeholder,\n.contact-number-input input::placeholder {\n  font-weight: 400;\n  font-size: 15px;\n  color: rgba(17, 17, 19, 0.6);\n}\n\n.reason-input textarea::placeholder {\n  font-family: Karla, sans-serif;\n}\n\n.details-dropdown select {\n  color: rgba(17, 17, 19, 0.6);\n}\n\n.details-dropdown select option {\n  font-weight: 400;\n  font-size: 12px;\n  color: rgba(17, 17, 19, 0.6);\n}\n\n.react-datepicker__input-container input,\n.email-input input,\n.reason-input textarea,\n.password-input input,\n.name-input input,\n.contact-number-input input {\n  font-weight: 400;\n  font-size: 15px;\n  color: rgba(17, 17, 19, 0.6);\n}\n\n.sign-in-form .form-title {\n  font-size: 40px;\n}\n\n.sign-in-form h3 {\n  font-size: 18px;\n}\n\n.react-datepicker__input-container {\n  display: block;\n  width: 100%;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown {\n  background-color: white;\n  border: 1px solid #aeaeae;\n  border-radius: 4px;\n  padding: 5px;\n}\n\n.react-datepicker__year-dropdown {\n  height: 200px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option {\n  padding: 2px 10px;\n  cursor: pointer;\n}\n\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover {\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow {\n  border-color: #aeaeae transparent transparent;\n  border-style: solid;\n  border-width: 5px 5px 2.5px;\n  height: 0;\n  margin-top: -2.5px;\n  position: absolute;\n  right: 5px;\n  top: 50%;\n  width: 0;\n}\n\n/*  */\n\n.password-input-container {\n  position: relative;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
